import React, { useEffect, useState } from 'react';
import { FaMobileAlt, FaUser, FaEnvelope, FaCalendarAlt, FaMapMarkerAlt } from "react-icons/fa";
import { FaShieldHalved, FaCodeBranch, } from "react-icons/fa6";
import { format, parse } from "date-fns";

import Header from '../../includes/Header';
import Footer from '../../includes/Footer';
import Sidebar from '../../includes/Sidebar';
import { Container, Row, Col } from 'react-bootstrap';

import { getProfile, postProfile, postSendOtp } from '../../apiservices/ApiServices';
import Loader from '../../components/Loader/Loader';

import { useFormik } from 'formik';
import { profileSchema } from '../../schemas';

import { ToastContainer, toast } from 'react-toastify';
import { useNavigate, Link } from "react-router-dom";


const Profile = () => {
    const [isLoading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [otpRequested, setOtpRequested] = useState(false);
    const navigate = useNavigate();

    const getProfiles = async () => {
        try {
            const res = await getProfile();
            setData(res.data.data);
            localStorage.setItem('userData', JSON.stringify(res.data.data));
            setLoading(false);
        } catch (error) {
            console.log(error.response.data.message);
            setLoading(false);
        }
    };

    useEffect(() => {
        setOtpRequested(false);
        if (!localStorage.getItem('userToken')) {
            navigate("/");
        }
        else {
            getProfiles();
        }
    }, [])

    const getPastDate = () => {
        const date = new Date();
        date.setFullYear(date.getFullYear() - 5);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
    };

    const handleProfile = async (values) => {
        setLoading(true);
        let postdata =
        {
            "id": data?.id || '',
            "first_name": values.firstName,
            "last_name": values.lastName,
            "gender": values.gender,
            "dob": values.dob,
            "email": values.email,
            "mobile_no": values.mobile,
            "otp": values.otp,
        }
        try {
            const res = await postProfile(postdata);
            //toast.success(res.data.message);
            getProfiles();
            setLoading(false);
            setOtpRequested(false);
        } catch (error) {
            setLoading(false);
            toast.error(error.response.data.message);
        }
    };

    const formik = useFormik({
        enableReinitialize: true, // Ensures form values update when data changes
        initialValues: {
            firstName: data?.first_name || '',
            lastName: data?.last_name || '',
            gender: data?.gender || '',
            dob: data?.dob || '',
            email: data?.email || '',
            mobile: data?.mobile_no || '',
            otp: '',
        },
        validationSchema: profileSchema(otpRequested),
        onSubmit: (values) => {
            handleProfile(values);
        }
    });

    const { values, errors, touched, handleBlur, handleChange, setFieldValue, handleSubmit } = formik;

    const handleDateChange = (e) => {
        const inputDate = e.target.value;
        if (inputDate) {
            const formattedDate = format(parse(inputDate, "yyyy-MM-dd", new Date()), "dd-MM-yyyy");
            setFieldValue("dob", formattedDate);
        }
    };

    const getFormattedDateForInput = (val) => {
        if (!val) return "";
        try {
            return format(parse(val, "dd-MM-yyyy", new Date()), "yyyy-MM-dd");
        } catch {
            return "";
        }
    };

    const handleSendOtp = async (mobile) => {
        let postdata =
        {
            "mobile_no": mobile,
        }
        try {
            const res = await postSendOtp(postdata);
            //toast.success(res.data.message);
            setOtpRequested(true);
        } catch (error) {
            setOtpRequested(false);
            toast.error(error.response.data.message);
        }
    };

    return (
        <>
            <Header toast={toast} />
            <ToastContainer />
            {isLoading ? (
                <Loader />
            ) : (
                <>
                    <div className="crumbsec">
                        <div className="wrap">
                            <Link to={'/'}>Home</Link>
                            <span className="sep">&rsaquo;</span>
                            <span className="cur">My Profile</span>
                        </div>
                    </div>

                    <section className="page-hero cart-hero">
                        <Container>
                            <div className="page-wrap hero-inner">
                                <div className="hero-title">
                                    <span className="hero-icon"><FaUser style={{ color: '#00a99d' }} /></span>
                                    <div>
                                        <h1>My Profile</h1>
                                        <p>Review your Profile.</p>
                                    </div>
                                </div>
                                <div className="hero-perks">
                                    <div className="hero-perk"><FaShieldHalved /><span><b>1-Year Warranty</b>on Premium Products</span></div>
                                    <div className="hero-perk"><FaCodeBranch /><span><b>2 Free Replacements</b>on Premium Shield</span></div>
                                    <div className="hero-perk"><FaShieldHalved /><span><b>Secure Checkout</b>100% Safe &amp; Trusted</span></div>
                                </div>
                            </div>
                        </Container>
                    </section>


                    <main className="main" style={{ paddingBottom: '50px' }}>
                        <Container>
                            <div className="layout">
                                <Sidebar />
                                <section className="content">
                                    <div className='forms'>
                                        <form id='profile' onSubmit={handleSubmit} autoComplete="off">
                                            <Row>
                                                <Col md={6}>
                                                    <div className="field">
                                                        <label for="name">First Name <span className="req">*</span></label>
                                                        <input
                                                            type="text"
                                                            id="firstName"
                                                            name="firstName"
                                                            placeholder="Enter Your First Name"
                                                            autoComplete='off'
                                                            value={values.firstName}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                        {errors.firstName && touched.firstName ? (
                                                            <p className='errormsg'>{errors.firstName}</p>
                                                        ) : null}
                                                    </div>
                                                </Col>
                                                <Col md={6}>
                                                    <div className="field">
                                                        <label for="name">Last Name <span className="req">*</span></label>
                                                        <input
                                                            type="text"
                                                            id="lastName"
                                                            name="lastName"
                                                            placeholder="Enter Your Last Name"
                                                            autoComplete='off'
                                                            value={values.lastName}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                        {errors.lastName && touched.lastName ? (
                                                            <p className='errormsg'>{errors.lastName}</p>
                                                        ) : null}
                                                    </div>
                                                </Col>

                                                <Col md={6}>
                                                    <div className="field">
                                                        <label for="name">Gender <span className="req">*</span></label>
                                                        <div className='rdoboxs'>
                                                            <label className='option'>
                                                                <input
                                                                    type="radio"
                                                                    name="gender"
                                                                    value="male"
                                                                    onChange={handleChange}
                                                                    checked={values.gender === "male"}
                                                                />
                                                                <span className="radio"></span>
                                                                Male
                                                            </label>
                                                            <label className='option'>
                                                                <input
                                                                    type="radio"
                                                                    name="gender"
                                                                    value="female"
                                                                    onChange={handleChange}
                                                                    checked={values.gender === "female"}
                                                                />
                                                                <span className="radio"></span>
                                                                Female
                                                            </label>
                                                            <label className='option'>
                                                                <input
                                                                    type="radio"
                                                                    name="gender"
                                                                    value="other"
                                                                    onChange={handleChange}
                                                                    checked={values.gender === "other"}
                                                                />
                                                                <span className="radio"></span>
                                                                Other
                                                            </label>
                                                        </div>
                                                    </div>
                                                </Col>

                                                <Col md={6}>
                                                    <div className="field">
                                                        <label for="name">Date of Birth. <span className="req">*</span></label>
                                                        <input
                                                            type="date"
                                                            id="dob"
                                                            name="dob"
                                                            placeholder='Enter Date of Birth'
                                                            autoComplete='off'
                                                            value={getFormattedDateForInput(values.dob)}
                                                            onChange={handleDateChange}
                                                            onBlur={formik.handleBlur}
                                                            max={getPastDate()}
                                                            onClick={(e) => e.target.showPicker()}
                                                            style={{
                                                                appearance: "none",
                                                                WebkitAppearance: "none",
                                                                MozAppearance: "none",
                                                            }}
                                                        />
                                                        {errors.dob && touched.dob ? (
                                                            <p className='errormsg'>{errors.dob}</p>
                                                        ) : null}
                                                    </div>
                                                </Col>
                                                <Col md={6}>
                                                    <div className="field">
                                                        <label for="name">Email Address. <span className="req">*</span></label>
                                                        <input
                                                            type="email"
                                                            id="email"
                                                            name="email"
                                                            placeholder="Enter Your Email Address"
                                                            autoComplete='off'
                                                            value={values.email}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                        {errors.email && touched.email ? (
                                                            <p className='errormsg'>{errors.email}</p>
                                                        ) : null}
                                                    </div>
                                                </Col>

                                                <Col md={6}>
                                                    <div className="field">
                                                        <label for="name">Mobile No. <span className="req">*</span></label>
                                                        <div className='mobileboxs'>
                                                            <span>+91</span>
                                                            <input
                                                                type="tel"
                                                                id="mobile"
                                                                name="mobile"
                                                                autoComplete='off'
                                                                placeholder="Enter Your Mobile No"
                                                                value={values.mobile}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />

                                                            {values.mobile !== data?.mobile_no && !errors.mobile && !otpRequested && (
                                                                <div className='otpbutton'>
                                                                    <button type="button" className="btn btn-link" onClick={() => handleSendOtp(values.mobile)}>Get OTP</button>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {errors.mobile && touched.mobile ? (
                                                            <p className='errormsg'>{errors.mobile}</p>
                                                        ) : null}
                                                    </div>
                                                </Col>
                                                {otpRequested ?
                                                    <Col md={6}>
                                                        <div className="field">
                                                            <label for="name">OTP <span className="req">*</span></label>
                                                            <input
                                                                type="text"
                                                                id="otp"
                                                                name="otp"
                                                                placeholder="Enter OTP"
                                                                autoComplete='off'
                                                                value={values.otp}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            {errors.otp && touched.otp ? (
                                                                <p className='errormsg'>{errors.otp}</p>
                                                            ) : null}
                                                        </div>
                                                    </Col> : null}
                                                <Col md={12}>
                                                    <div className='buttonbox'>
                                                        <button type='submit' className='btn btn-green'>Submit</button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </form>
                                    </div>
                                </section>
                            </div>
                        </Container>
                    </main>
                </>
            )}

            {/* <div className="trust">
                <div className="trust-in">
                    <div className="tr">
                        <div className="tr-ic"><svg viewBox="0 0 24 24" strokeWidth="1.6"><path d="M12 3 5 6v5c0 4.4 3 8.3 7 9.6 4-1.3 7-5.2 7-9.6V6l-7-3Z" /><path d="m9 12 2 2 4-4" /></svg></div>
                        <div><div className="tr-t">1 Year Warranty</div><div className="tr-s">On Premium Products</div></div>
                    </div>
                    <div className="tr">
                        <div className="tr-ic"><svg viewBox="0 0 24 24" strokeWidth="1.6"><path d="M20 11a8 8 0 0 0-14-4.5L4 8" /><path d="M4 4v4h4" /><path d="M4 13a8 8 0 0 0 14 4.5L20 16" /><path d="M20 20v-4h-4" /></svg></div>
                        <div><div className="tr-t">2 Free Replacements</div><div className="tr-s">We've Got You Covered</div></div>
                    </div>
                    <div className="tr">
                        <div className="tr-ic"><svg viewBox="0 0 24 24" strokeWidth="1.6"><path d="M12 3 5 6v5c0 4.4 3 8.3 7 9.6 4-1.3 7-5.2 7-9.6V6l-7-3Z" /><path d="m9 12 2 2 4-4" /></svg></div>
                        <div><div className="tr-t">Secure Payments</div><div className="tr-s">100% Safe &amp; Secure</div></div>
                    </div>
                </div>
            </div> */}

            <Footer toast={toast} />
            {isLoading ? <Loader /> : null}
        </>
    )
}

export default Profile;